import { MicrofrontendPrefix } from './core/enums/microfrontend-prefix.enum';
import { MicrofrontendType } from './core/enums/microfrontend-type.enum';
import { IMicrofrontend } from './interfaces/microfrontend.interface';

export const microfrontendSources: Record<MicrofrontendType, IMicrofrontend> = {
    [MicrofrontendType.appointment]: {
        id: MicrofrontendType.appointment,
        entryPointUrl: `/doctor-frontend/appointment/doctor-entry.js`,
        servicePrefix: MicrofrontendPrefix.appointmentApp,
    },
    [MicrofrontendType.protocol]: {
        id: MicrofrontendType.protocol,
        entryPointUrl: `/doctor-frontend/screening-components/protocol-entry.js`,
        servicePrefix: MicrofrontendPrefix.protocolApp,
    },
    [MicrofrontendType.protocolConstructor]: {
        id: MicrofrontendType.protocolConstructor,
        entryPointUrl: `/doctor-frontend/protocol-constructor/protocol-constructor-entry.js`,
        servicePrefix: MicrofrontendPrefix.protocolConstructorApp,
    },
};
